// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import LevelMeter from '../../components/LevelMeter';
import Button from '../../components/Button';
import TopBg from './assets/Banner.png';
import Column from '../../components/Column';
import InfoText from '../../components/NewCard/components/InfoText';
import CheckBox from '../../components/CheckBox';
import LanguageIcon from '../../assets/images/card-language-icon.svg';
import CheckIcon from './assets/check-circle-icon.svg';
import AlarmIcon from './assets/alarm-icon.svg';
import Tooltips from '../../components/Tooltips';
import InfoIcon from '../../assets/images/info.svg';

const otherS = {
  Container: styled.div`
    width: 100%;
    max-width: 1366px;
    margin: 0 auto;
  `,
  LoadingContainer: styled.div`
    display: flex;
    margin-top: auto;
    place-content: center;
  `,
  WrapperTop: styled.div`
    background: transparent url(${TopBg}) 0% 0% no-repeat padding-box;
    background-size: cover;
    padding: 24px 60px 26px 60px;
    display: flex;
    place-content: center;
    justify-content: center;
  `,
  LeftWrapper: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 484px;
    flex: 1;
  `,
  RightWrapper: styled.div`
    max-width: 560px;
    flex: 1;
    position: relative;
  `,
  Badge: styled.img`
    position: absolute;
    left: -19px;
    transform: translateX(-100%);
  `,
  Information: styled(Column)`
    flex: 1;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    color: #434343;
    margin-top: 8px;
    margin-bottom: 22px;
    margin-right: 0px;
    margin-left: 0px;

    > * + * {
      margin-top: 10px;
    }
  `,
  Description: styled.div`
    flex: 1;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    color: #434343;
  `,
  Email: styled.span`
    text-decoration: underline;
  `,
  LevelMeter: styled(LevelMeter)`
    font-size: 16px;
    line-height: 23px;
    color: #434343;
  `,
  Title: styled.h1`
    font-weight: bold;
    font-size: 28px;
    line-height: 41px;
    color: #434343;
  `,
  Instructors: styled.span`
    margin-top: 8px;
    font-size: 20px;
    line-height: 23px;
    color: #666666;
  `,
  Domains: styled.div`
    margin-top: 17px;
    font-size: 12px;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0em;
  `,
  Button: styled(Button)`
    width: 100%;
    font-size: 16px;
  `,
  Body: styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    padding: 24px 60px 0 60px;
    place-content: center;
    justify-content: center;
  `,
  InfoBox: styled.div`
    flex-shrink: 0;
    width: 255px;
    display: flex;
    flex-direction: column;

    & > * + * {
      margin-top: 36px;
    }
  `,
  Info: styled.div`
    display: flex;
    align-items: center;
  `,
  Contents: styled.div`
    margin-left: 51px;
    flex: 1;
  `,
  InfoText: styled(InfoText)<{ highlight?: boolean }>`
    display: flex;
    align-items: center;
    font: 14px Noto Sans TC;
    color: #313131;
    
    ${props => props.highlight ? `
      font-weight: 600;
      justify-content: center;
      border-left: 2px solid #EF8200;
      border-right: 2px solid #EF8200;
      border-radius: 5px;
      img {
        width: 18px;
        height: 18px;
        margin-left: 4px;
      }
    ` : `
      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
    `} 
  `,
  TimeUpContainer: styled(Column)`
    height: 100%;

    > * + * {
      margin-top: 36px;
    }
  `,
  TimeUpP: styled.p`
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #313131;
  `,
  Img: styled.img``,
  TimeUpButton: styled(Button)`
    width: 142px;
    height: 44px;
  `,
  DownloadLoadingContainer: styled.div`
    width: 255px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  DownloadResultContainer: styled.div`
  `,
  DownloadButtonContainer: styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
  `,
  DownloadText: styled.div`
    width: 255px;
    text-align: center;
    color: #313131;
  `,
  DownloadButton: styled.a`
    color: #EF8200;
  `,
  ErrorText: styled.div<{ downloadError:boolean }>`
    ${props => props.downloadError ? `
      text-align: center;
      color: red;
      display: block;
      width: 255px;
    ` : 'display: none;'}
  `,
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
  `,
  ChooseDownloadWapper: styled.div`
    background: #FFFFFF;
    border-radius: 11px;
    margin-top: 11px;
    position: fixed;
    font-size: 26px;
    line-height: 38px;
    color: #353535;
    top: 10%;
    left: 50%;
    transform: translate(-51%,0%);
  `,
  CloseBar: styled.div`
    background: #EF8200;
    border-radius: 11px 11px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  CloseIconContainer: styled.div`
    padding: 0px 17px 4px;
    cursor: pointer;
  `,
  ChooseDownloadCard: styled.div`
    padding: 20px 80px;
    text-align: center;
  `,
  ChooseDownloadTitle: styled.p`
    color: #353535;
    font-size: 20px;
  `,
  ChooseDownloadContent: styled.div`
    margin: 10px 0px 30px 60px;
    display: flex;
    flex-direction: column;
    max-height: 300px;
    overflow-y: auto;
    & :first-child {
      margin-left: -17px;
      padding-bottom: 8px;
    }
    &::-webkit-scrollbar {
      width: 7px;
    }
    &::-webkit-scrollbar-button {
      background: transparent;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #E6E6E6;
      border: 1px solid #E6E6E6;
    }
    &::-webkit-scrollbar-track {
      box-shadow: transparent;
    }
  `,
  MemberCheckBox: styled(CheckBox)`
    justify-content: flex-start;
    color: #767676;
    padding: 3px 0 3px 20px;
  `,
  MemberCheckBoxText: styled.div`
  `,
  SubmitAction: styled.div`
    display: flex;
    justify-content: center;
  `,
  CancelButton: styled(Button)`
    background: #7A7A7A;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 7px 0px 0px 7px;
    padding: 4px 27px;
    margin-right: 14px;
  `,
  SubmitButton: styled(Button)`
    background: #EF8200;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 0px 7px 7px 0px;
    padding: 4px 27px;
  `,
  CloseIcon: styled.div`
    display: inline-block;
    width: 14px;
    height: 2px;
    background: #FFF;
    line-height: 0;
    font-size: 0;
    vertical-align: middle;
    transform: rotate(45deg);
    &::after {
      content: "/";
      display: block;
      width: 14px;
      height: 2px;
      background: #FFF;
      transform: rotate(-90deg);
    }
  `,
  CheckContainer: styled.div`
    display: flex;
    gap: 1rem;
  `,
  LanguageIcon: styled.img.attrs({ src: LanguageIcon })`
    width: 20px;
    height: 20px;
    margin-right: 4px;
  `,
  CheckInfo: styled.div`
    text-align: center;
  `,
  CheckIcon: styled.img.attrs({ src: CheckIcon })`
    width: 20px;
    height: 20px;
    margin-right: 4px;
  `,
  AlarmIcon: styled.img.attrs({ src: AlarmIcon })`
    width: 20px;
    height: 20px;
    margin-left: 4px;
  `,
  BtnContainer: styled.div`
    position: relative;
    width: 100%;
  `,
  Tooltips: styled(Tooltips).attrs({ direction: 'bottomRight' })<{ show?: boolean }>`
    position: absolute;
    display: ${props => props.show ? 'flex' : 'none'};
    top: -115px;
    width: 125%;
  `,
  InfoTooltips: styled(Tooltips).attrs({ direction: 'bottomRight' })<{ show?: boolean }>`
    position: absolute;
    display: ${props => props.show ? 'flex' : 'none'};
    top: -80px;
  `,
  InfoIcon: styled.img.attrs({ src: InfoIcon })`
    cursor: pointer;
  `,
};
export const S = {
  ...otherS,
}
